var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "button-icon",
      class: { disabled: _vm.disabled },
      style: { "min-width": _vm.width },
      attrs: {
        "aria-disabled": _vm.disabled,
        disabled: _vm.disabled,
        href: _vm.href,
        to: _vm.to
      },
      on: { click: _vm.onClick }
    },
    [
      _c("span", {
        staticClass: "icon",
        class:
          ((_obj = {}),
          (_obj[_vm.icon] = _vm.icon),
          (_obj[_vm.color] = _vm.color),
          _obj),
        style: { "font-size": _vm.size }
      }),
      _vm._v(" "),
      _vm.label
        ? _c(
            "span",
            {
              staticClass: "label",
              class: ((_obj$1 = {}), (_obj$1[_vm.color] = _vm.color), _obj$1)
            },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74add53e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74add53e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/button-icon.vue
// module id = 1258
// module chunks = 0